import { BarChartOutlined } from "@ant-design/icons";

export default function Empty({ title }: any) {
  return (
    <div className="">
      <div className="border-b-4 border-gray-100 bg-gray-50 p-2  flex justify-between">
        <div className="font-bold"></div>
        <button className="flex justify-center items-center text-gray-50">
          View All
        </button>
      </div>
      <div className="flex flex-col items-center justify-center w-full h-full text-6xl text-gray-400 mt-6">
        <BarChartOutlined size={40} />
        <div className="text-xxs mt-3">{title}</div>
      </div>
    </div>
  );
}
